"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenScriptsResponseToJSON = exports.GenScriptsResponseFromJSONTyped = exports.GenScriptsResponseFromJSON = exports.instanceOfGenScriptsResponse = void 0;
var runtime_1 = require("../runtime");
var GeneratedScript_1 = require("./GeneratedScript");
var GenerationError_1 = require("./GenerationError");
/**
 * Check if a given object implements the GenScriptsResponse interface.
 */
function instanceOfGenScriptsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGenScriptsResponse = instanceOfGenScriptsResponse;
function GenScriptsResponseFromJSON(json) {
    return GenScriptsResponseFromJSONTyped(json, false);
}
exports.GenScriptsResponseFromJSON = GenScriptsResponseFromJSON;
function GenScriptsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'scripts': !(0, runtime_1.exists)(json, 'scripts') ? undefined : (json['scripts'].map(GeneratedScript_1.GeneratedScriptFromJSON)),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (json['errors'].map(GenerationError_1.GenerationErrorFromJSON)),
    };
}
exports.GenScriptsResponseFromJSONTyped = GenScriptsResponseFromJSONTyped;
function GenScriptsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'scripts': value.scripts === undefined ? undefined : (value.scripts.map(GeneratedScript_1.GeneratedScriptToJSON)),
        'errors': value.errors === undefined ? undefined : (value.errors.map(GenerationError_1.GenerationErrorToJSON)),
    };
}
exports.GenScriptsResponseToJSON = GenScriptsResponseToJSON;
